import React from 'react';
import AppointmentOverview from '../AppointmentOverview';

export const InHomeOverviewPanel = ({
    className,
    ...props
}) => {

    return (<>
        <div className={`col-12 col-xl pl-0 pr-0 in-home-overview-panel-container ${className ? className : ''}`}>
            <AppointmentOverview {...props} />
        </div>
    </>);
}

